/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');
var GridView = require('psa-marionette/views/GridView');

var GetAllInternalTasks = require('../services/GetAllInternalTasks');

module.exports = {
  channel: 'sc:internal-dashboard',

  event: 'build:sec-internal-all-tasks-grid-view',

  builder: function(gridColumns) {
    var deferred = $.Deferred();

    GetAllInternalTasks()
      .done(function(allTasks) {
        deferred.resolve(
          new GridView({
            columns: gridColumns,
            collection: new PageableCollection(allTasks, { pageSize: 25 }),
            emptyText: 'No Tasks.'
          })
        );
      })
      .fail(function(err) {
        deferred.reject(err);
      });

    return deferred.promise();
  }
};
